import React from 'react';
import { permissionObj } from '../../../../Helpers/permission';
import SearchFor from '../../../Modals/SearchFor';
import ButtonIcon from '../../../../components/buttons/ButtonIcon';
import SearchFilterBtn from '../../../../components/buttons/SearchFilterBtn';
import DeleteModal from '../../../Modals/DeleteModal';
import ExportDataBtn from '../../../../components/buttons/ExportDataBtn';
import ImportFileModal from '../../../Modals/ImportFileModal';
import HeadTittle from '../../../../components/HeadTittle';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import {
    AddIcon,
    CustomHeaderIcon,
    EditIcon,
    TrashOutlineIcon,
    UserRestrictionIcon,
    VCardIcon
} from '../../../../components/buttons/IconButtons';
import routes from '../../../../Routes/routes';
import CustomExpandImage from "../../../../components/CustomExpandImage";
import { VIEW_TYPE } from "../../../../enums/ViewType";
import { USER_ACCESS_KEY_MODEL } from "../../../../enums/userTypeEnum";
import AllEmployeesTable from './Table/AllEmployeesTable';
import AllEmployeeCards from './SubComponents/AllEmployeeCards';
import AllEmployeeApp from './Functionality/AllEmployeeApp';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AllEmployees = () => {

    const {
        t,
        permission,
        DEV,
        moduleId,
        option,
        getUserRestriction,
        contractorId, supplierId,
        view, setView,
        importFileShow, setImportFileShow,
        criteria, setCriteria,
        search, setSearch,
        setSimpleSearch,
        searchElement, setSearchElement,
        bodyForExport, setBodyForExport,
        selectForDelete, setSelectForDelete,
        deleteEmployeeShow, setDeleteEmployeeShow,
        finalArray, setFinalArray,
        isAllChecked, setIsAllChecked,
        expandImage, setExpandImage,
        modified, setModified,
        filterDialogShow, setFilterDialogShow,
        goCreate,
        deleteSelectedEmployees,
        handleView,
        showActionsContractorSupplier
    } = AllEmployeeApp();

    return (
        <>
            <HeadTittle name={'employees'}>
                {!contractorId && !supplierId &&
                    <>
                        {(DEV || permission?.includes(permissionObj?.WEB_USER_RESTRICTION_UPDATE)) && (
                            <ButtonIcon
                                id='btn_ae_user_restriction'
                                Icon={UserRestrictionIcon}
                                url={routes.restriction.userRestriction}
                                title={'user_restriction'}
                                iconProps={'btn-icon-svg-12px icon-color-general-00'}
                            />
                        )}
                        {getUserRestriction.extraDataEmployee && (DEV || permission?.includes(permissionObj?.WEB_VCARD_SETTINGS_UPDATE)) && (
                            <ButtonIcon
                                id='btn_ae_v_card_settings'
                                Icon={VCardIcon}
                                url={routes.restriction.vcardSettings}
                                title={'vCardSettings'}
                                iconProps={'btn-icon-svg-12px icon-color-general-00'}
                            />
                        )}
                        {(DEV || permission?.includes(permissionObj?.WEB_HEADERS_UPDATE)) && (
                            <ButtonIcon
                                id='btn_ae_headers'
                                Icon={CustomHeaderIcon}
                                url={routes.headers.headers}
                                title={'custom_headers'}
                                iconProps={'btn-icon-svg-12px icon-color-general-00'}
                            />
                        )}
                    </>
                }

                {(showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_IMPORT)) &&
                    <ButtonAction
                        id='btn_ae_import_data'
                        name='import_data'
                        className='btn-icon-accent-450'
                        splitName={false}
                        Icon={EditIcon}
                        disabled={false}
                        onClick={() => {
                            setImportFileShow(true);
                        }}
                    />
                }

                {(showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_EXPORT)) &&
                    (search ? (
                        <ExportDataBtn
                            moduleId={moduleId}
                            body={criteria}
                            search={search}
                            option={option}
                        />
                    ) : (
                        <ExportDataBtn
                            moduleId={moduleId}
                            searchElement={searchElement}
                            search={search}
                            option={option}
                            body={bodyForExport}
                        />
                    ))}

                {(showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_CREATE)) && (
                    <ButtonAction
                        id='btn_ae_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            goCreate();
                        }}
                    />
                )}

                {(showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DELETE)) && (
                    <ButtonAction
                        id='btn_ae_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectForDelete?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteEmployeeShow(true);
                        }}
                    />
                )}

                <SearchFilterBtn finalArray={finalArray}
                    fnclick={() => {
                        if (selectForDelete?.length > 0)
                            setSelectForDelete([])
                        setFilterDialogShow(true)
                    }}
                />

            </HeadTittle>

            {view === VIEW_TYPE.LIST.name &&
                <AllEmployeesTable
                    contractorId={contractorId}
                    supplierId={supplierId}

                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}

                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    selectedList={selectForDelete}
                    setSelectedList={setSelectForDelete}

                    setExpandImage={setExpandImage}
                    modified={modified}
                    setModified={setModified}

                    finalArray={finalArray}
                    view={view}
                    setView={setView}
                    criteria={criteria}
                    setCriteria={setCriteria}
                    option={option}
                    setBodyForExport={setBodyForExport}
                    goCreate={goCreate}
                    handleView={handleView}
                    showActionsContractorSupplier={showActionsContractorSupplier}
                />
            }

            {view === VIEW_TYPE.GRID.name &&
                <AllEmployeeCards
                    contractorId={contractorId}
                    supplierId={supplierId}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    selectedList={selectForDelete}
                    setSelectedList={setSelectForDelete}
                    modified={modified}
                    setModified={setModified}
                    finalArray={finalArray}
                    view={view}
                    setView={setView}
                    criteria={criteria}
                    setCriteria={setCriteria}
                    option={option}
                    setBodyForExport={setBodyForExport}
                    goCreate={goCreate}
                    handleView={handleView}
                    showActionsContractorSupplier={showActionsContractorSupplier}
                />
            }

            {(filterDialogShow || finalArray?.length > 0) &&
                <SearchFor
                    open={filterDialogShow}
                    onClose={() => {
                        setFilterDialogShow(false);
                    }}
                    onFiltered={(originalArray) => {
                        setFilterDialogShow(false);
                        setFinalArray(originalArray);
                        setSearchElement(''); // clean search component
                    }}
                    moduleId={moduleId}
                    option={option}
                    finalArray={finalArray}
                    cleanAdvance={modified}
                    setCleanAdvance={setModified}
                    search={search}
                    setSearch={setSearch}
                    setFinalArray={setFinalArray} //Use for clean all filters in advanced search
                    searchElement={searchElement} // Use for detect search component changes
                />
            }

            <DeleteModal
                show={deleteEmployeeShow}
                onHide={() => setDeleteEmployeeShow(false)}
                onClickFn={() => deleteSelectedEmployees(selectForDelete)}
                data={selectForDelete}
                isReset={setSelectForDelete}
                isAllReset={setIsAllChecked}
                title_modal={t('delete')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('employees')}
            />

            <ImportFileModal
                show={importFileShow}
                onHide={() => setImportFileShow(false)}
                onCreated={() => setModified(true)}
                title_modal={t('import')}
                element_modal={t('employees')}
                model={
                    contractorId !== null ?
                        USER_ACCESS_KEY_MODEL.CONTRACTOR_EMPLOYEE : supplierId !== null ?
                            USER_ACCESS_KEY_MODEL.SUPPLIER_EMPLOYEE : USER_ACCESS_KEY_MODEL.EMPLOYEE
                }
            />

            <CustomExpandImage expandImage={expandImage} setExpandImage={setExpandImage}/>
        </>
    );
};

export default AllEmployees;
